var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea-autosize',{staticClass:"modal-textarea-catchy-title",style:({color: _vm.card.textColor}),model:{value:(_vm.section.value),callback:function ($$v) {_vm.$set(_vm.section, "value", $$v)},expression:"section.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }